export default __webpack_public_path__ + "static/media/Verladung Porsche KS juli 2019 17_1.71a90e4b.jpg";